export const adIdRoles = [
  {
    role_name: "Executive",
    ad_id: "fc35ad06-a1e9-4abf-b572-6277f9a4f04b",
    group_name: "Supplier Spend Visibility - Executive",
  },
  {
    role_name: "SCM Manager",
    ad_id: "a61c5282-f507-4a39-a7a8-d8b9b4e1c3b4",
    group_name: "Supplier Spend Visibility - SCM Manager",
  },
  {
    role_name: "Category Manager",
    ad_id: "5262fb91-31b2-4650-a87e-0acbf45f0dab",
    group_name: "Supplier Spend Visibility - Category Manager",
  },
  {
    role_name: "Business Stakeholder",
    ad_id: "0d34ed79-bf66-45b0-b8b1-211357d342d9",
    group_name: "Supplier Spend Visibility - Business Stakeholder",
  }
];
